import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
const Layout = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-31">
      <Sidebar data-id="element-32" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-33">
        <Navbar data-id="element-34" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-35">
          <Outlet data-id="element-36" />
        </main>
      </div>
    </div>;
};
export default Layout;